import { Component, input } from '@angular/core';

/**
 * Bloc "état vide" (icône + titre + message), dupliqué à l'identique sur
 * plusieurs pages (users, ads, documents, properties, plans). `size` et
 * `iconVariant` couvrent les variantes de gabarit déjà présentes dans le
 * code existant — ce ne sont pas de nouvelles options inventées :
 *  - `md`  : gabarit standard (user-list, ad-list, document-list, property-list)
 *  - `sm`  : gabarit compact (property-detail)
 *  - `lg`  : carte encadrée en pointillés (plan-list)
 *  - iconVariant 'success' : icône verte utilisée pour les onglets « en attente »
 *    une fois vidés (ex : « Aucune publicité en attente »)
 */
@Component({
  selector: 'app-empty-state',
  standalone: true,
  templateUrl: './app-empty-state.html',
  styleUrl: './app-empty-state.scss'
})
export class AppEmptyState {
  icon = input<string>('pi-inbox');
  title = input<string>('');
  message = input<string>('');
  size = input<'sm' | 'md' | 'lg'>('md');
  iconVariant = input<'neutral' | 'success'>('neutral');
}
